import apiClient from "./apiService";
import { StudentExam, StudentExamsQueryParams } from "@/interfaces/StudentExam";

export default {
  async getStudentExams(url: string, params?: StudentExamsQueryParams) {
    try {
      const response = await apiClient.get(url, { params });
      return response; 
    } catch (error) {
      console.error("Error fetching student's exams:", error);
      throw error;
    }
  },
};
